import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import Feedback from "../../../classes/Feedback";

export default {
  routes: [
    {
      name: "feedback",
      path: "feedback/:filter?",
      meta: {
        auth: () => Feedback.canBeViewedBy(store.state.main.user),
        icon: "feedback",
        title: i18n.global.t("Feedback"),
        crumbs: ["admin"],
        color: "admin",
      },
      component: () => import("pages/admin/Feedback"),
    },
  ],

  dialogs: [
    {
      name: "feedback-request",
      path: "/admin/feedback/request",
      meta: {
        auth: () => Feedback.canBeCreatedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/FeedbackRequest"),
    },
    {
      name: "feedback-view",
      path: "/admin/feedback/:feedbackID/view",
      meta: {
        auth: () => Feedback.canBeViewedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/FeedbackView"),
    },
  ],
};
